import React,{useState} from 'react';
import './style.css';
import tile1 from '../../assets/images/tile1.svg'; 
import tile2 from '../../assets/images/tile2.svg'; 
import tile3 from '../../assets/images/tile3.svg'; 
import tile4 from '../../assets/images/tile4.svg'; 
import tile5 from '../../assets/images/tile5.svg'; 
import tile6 from '../../assets/images/tile6.svg'; 
import { ReactComponent as DownloadIcon} from '../../assets/images/download-icon.svg'; 

const CustomScenes = () => {

  const [button1, setButton1] = useState(false);
  const [button2, setButton2] = useState(false);
  const [button3, setButton3] = useState(false);
  const [button4, setButton4] = useState(false);
  const [button5, setButton5] = useState(false);
  const [button6, setButton6] = useState(false);

  return(
  <div className="custom-scenes-wrapper px-6 md:px-24 sm:pb-20 sm:pt-20">
    <div className="scenes-container flex-col">
      <div className="heading ">
        <h1 className="w-5/6 lg:w-2/3 font-extrabold text-4xl sm:text-6xl custom-scenes-heading leading-none main-font">Recreate art</h1>
        <h1 className="w-5/6 lg:w-2/3 font-extrabold text-4xl sm:text-6xl custom-scenes-heading leading-none main-font">your way.</h1>
        {/* <h1 className="font-extrabold text-4xl sm:text-5xl custom-scenes-heading leading-relaxed">ready for you! </h1> */}
        <p className="pr-2 mt-6 leading-6 w-full lg:w-2/5 font-light options-para text-left	 secondary-font story-free-comm lg:text-2xl sm:text-lg">
          Add a little aura, change the mood with some backgrounds.
        </p>
        {/* <p className="text-sm font-normal custom-scenes-para ">for you; just drag & drop these illustrations and start creating.</p> */}
      </div>
      <div className="tilesWrapper">
        <div 
          className="tiles" 
          onMouseOver={() => setButton1(true)}
          onMouseLeave={() => setButton1(false)}
          style={{backgroundImage: `url(${tile1})`}}
        > 
          {button1 && 
            <a href={ tile1 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center" 
              download
              aria-label="Download scene 1 with office background and two human illustrations in SVG format."
            > 
              <DownloadIcon 
                className="downloadicon interact-icon" 
                aria-label="Click here to download."  
              />
            </a >
          }
        </div>
        <div 
          className="tiles" 
          style={{ backgroundImage: `url(${tile2})`}}
          onMouseOver={() => setButton2(true)}
          onMouseLeave={() => setButton2(false)}
        >
          {button2 && 
            <a href={ tile2 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center" 
              download
              aria-label="Download scene 2 with space background and two human illustrations in SVG format."
            > 
              <DownloadIcon 
                className="downloadico interact-icon"
                aria-label="Click here to download."  
              />
            </a >
          }
        </div>
        <div 
          className="tiles" 
          style={{ backgroundImage: `url(${tile3})`}}
          onMouseOver={() => setButton3(true)}
          onMouseLeave={() => setButton3(false)}
        >
          {button3 &&
            <a href={ tile3 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center"
              download
              aria-label="Download scene 3 with office background and two human illustrations in SVG format."
            > 
              <DownloadIcon 
                className="downloadico interact-icon"
                aria-label="Click here to download."  
              />
            </a >
          }
        </div>
        <div 
          className="tiles" 
          style={{ backgroundImage: `url(${tile4})`,}}
          onMouseOver={() => setButton4(true)}
          onMouseLeave={() => setButton4(false)}
        >
          {button4 &&
            <a href={ tile4 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center"
              download
              aria-label="Download scene 4 with office background and two human illustrations in SVG format."
            > 
              <DownloadIcon 
                className="downloadico interact-icon"
                aria-label="Click here to download."  
              />
            </a >
          }
        </div>
        <div 
          className="tiles" 
          style={{ backgroundImage: `url(${tile5})`,}}
          onMouseOver={() => setButton5(true)}
          onMouseLeave={() => setButton5(false)}
        >
          {button5  &&
            <a href={ tile5 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center" 
              download
              aria-label="Download scene 5 with a musical background at home and two human illustrations in SVG format."
            >
              <DownloadIcon 
                className="downloadico interact-icon"
                aria-label="Click here to download."  
              />
            </a >
          }  
        </div> 
        <div 
          className="tiles" 
          style={{ backgroundImage: `url(${tile6})`,}}
          onMouseOver={() => setButton6(true)}
          onMouseLeave={() => setButton6(false)}
        >
          {button6 &&
            <a href={ tile6 } className="custom-scene-btn1 rounded-full w-6 h-6 sm:w-10 sm:h-10 flex justify-center items-center"
              download
              aria-label="Download scene 6 with wireframe backdrop and two human illustrations in SVG format."  
            > 
              <DownloadIcon
                className="downloadico interact-icon"
                aria-label="Click here to download."  
              />
            </a >
          }
        </div>
      </div>
    </div>
  </div>
  )
}

export default CustomScenes;